import React from 'react';

const JsonValue = ({value, indentLevel}) => {
    const type = typeof value;

    if (value === null) {
        return <span className="text-purple-600">null</span>;
    }

    switch (type) {
        case 'string':
            return <span className="text-green-600" style={{whiteSpace: "nowrap"}}>"{value}"</span>;
        case 'number':
            return <span className="text-yellow-600">{value}</span>;
        case 'boolean':
            return <span className="text-blue-600">{String(value)}</span>;
        case 'object':
            if (Array.isArray(value)) {
                if (value.length === 0) return <span className="text-gray-600">[]</span>;

                const indent = ' '.repeat(indentLevel * 2);
                const childIndent = ' '.repeat((indentLevel + 1) * 2);

                return (
                    <>
                        <span className="text-gray-600">{'[\n'}</span>
                        {value.map((item, index) => (
                            <React.Fragment key={index}>
                                {childIndent}
                                <JsonValue value={item} indentLevel={indentLevel + 1}/>
                                {index < value.length - 1 ? <span className="text-gray-600">,</span> : ''}
                                {'\n'}
                            </React.Fragment>
                        ))}
                        <span className="text-gray-600">{indent}{']'}</span>
                    </>
                );
            }

            const entries = Object.entries(value);
            if (entries.length === 0) return <span className="text-gray-600">{'{ }'}</span>;

            const indent = ' '.repeat(indentLevel * 2);
            const childIndent = ' '.repeat((indentLevel + 1) * 2);

            return (
                <>
                    <span className="text-gray-600">{`{\n`}</span>
                    {entries.map(([key, val], index) => (
                        <React.Fragment key={key}>
                            {childIndent}
                            <span className="text-blue-600">"{key}"</span>
                            <span className="text-gray-600">: </span>
                            <JsonValue value={val} indentLevel={indentLevel + 1}/>
                            {index < entries.length - 1 ? <span className="text-gray-600">,</span> : ''}
                            {'\n'}
                        </React.Fragment>
                    ))}
                    <span className="text-gray-600">{indent}{'}'}</span>
                </>
            );
        default:
            return null;
    }
};

const JsonViewer = ({data}) => {
    return <div className="px-4 py-2 text-sm">
        <pre>
          <code>
            <JsonValue value={data} indentLevel={0}/>
          </code>
        </pre>
    </div>
};

export default JsonViewer;
